import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./Pages/Home/Home";
import Login from "./Pages/Login/Login";
import SignUp from "./Pages/SignUp/SignUp";
import MultiStepForm from "./Pages/Form/MultiStepForm";
import Expired from "./Pages/Expired/Expired";
import Verifier from "./Pages/Admin/Verifier/Verifier";
import NotAuthorised from "./Pages/NotAuthorised/NotAuthorised";
import Waiting from "./Pages/Waiting/waiting";
import UserApproval from "./Pages/Admin/Dashboard/User_Approval";
import Success from "./Pages/Success/Success";
import Verify from "./Pages/verify";
import ChangePassword from "./Pages/ChangePassword/ChangePassword";

function Routes1() {
  return (
    <Router>
      <Routes>
        <Route exact path="/Login" element={<Login />} />
        <Route exact path="/SignUp" element={<SignUp />} />
        <Route exact path="/Form" element={<MultiStepForm />} />
        <Route exact path="/Expired" element={<Expired />} />
        <Route exact path="/waiting" element={<Waiting />} />
        <Route exact path="/NotAuthorised" element={<NotAuthorised />} />
        <Route exact path="/Success" element={<Success />} />
        <Route exact path="/verify" element={<Verify />} />
        {/* Admin/Dashboard pages  */}
        <Route exact path="/Form/:appId" element={<MultiStepForm />} />
        <Route exact path="/Admin/Verifier" element={<Verifier />} />
        <Route exact path="/change-password" element={<ChangePassword />} />
        <Route
          exact
          path="/Admin/Dashboard/User_Approval"
          element={<UserApproval />}
        />
      </Routes>
    </Router>
  );
}

export default Routes1;
